import React from 'react';
import { FormGroup, Label, InputGroup, InputGroupAddon, Input } from 'reactstrap';

type Props = {
  title: string,
  value: number,
  minValue: number,
  disabled: boolean,
  defaultValue: Number,
  onChange: (value: number) => void,
};

const Counter = ({ title, onChange, value, minValue = 1, disabled = false }: Props) => (
  <FormGroup className="cta-input-box" disabled={disabled}>
    <Label>{title}</Label>
    <InputGroup>
      <InputGroupAddon
        onClick={() => {
          if (value > minValue && !disabled) onChange(Number(value) - 1);
        }}
        addonType="prepend"
      >
        <span className="input-group-text">
          <i className="icon icon-hg-minus" />
        </span>
      </InputGroupAddon>

      <Input value={value} type="text" readOnly="readyonly" min="1" />

      <InputGroupAddon
        onClick={() => !disabled && onChange(Number(value) + 1)}
        addonType="append"
      >
        <span className="input-group-text">
          <i className="icon icon-hg-plus" />
        </span>
      </InputGroupAddon>
    </InputGroup>
  </FormGroup>
);

export default Counter;



// WEBPACK FOOTER //
// ./src/components/Counter/Counter.jsx